import { useTranslation } from "react-i18next";
import { useEffect, useState, useRef } from 'react';
import '../../../styles/game/InfoBoard.css';
import '../../../styles/game/InfoBoardTabs.css';
import '../../../styles/game/InfoBoardComponents.css';
import FairnessModal from '../FairnessModal.jsx';
import { t } from "i18next";

function Multipliers({isDay, setIsDay, isMonth, setIsMonth, isYear, setIsYear }) {

    const sliderRef = useRef(null);
    const [isOption, setIsOption] = useState(() => {
        if (isDay) return 'day';
        if (isMonth) return 'month';
        if (isYear) return 'year';
    });
    const [topRounds, setTopRounds] = useState([])
    const [isLoading, setIsLoading] = useState(true)
    const [isFairnessOpen, setIsFairnessOpen] = useState(false)
    const [roundId, setRoundId] = useState(0)
    
    const closeFairnessModal = () => {
        setTimeout(() => {
            setIsFairnessOpen(false);
        }, 200)
    }





    useEffect(() => {
        
            if (isDay) {
                
                setIsOption('day')
            } else if (isMonth) {
                
                setIsOption('month')
            } else if (isYear) {
                
                setIsOption('year')
            }
        
    }, [isDay, isMonth, isYear]);
    const handleNavClick = (tab) => {
        setIsDay(tab === "allBets");
        setIsMonth(tab === "myBets");
        setIsYear(tab === "top");
    };



    useEffect(() => {
        setIsLoading(true)
        setTopRounds([])
        const fetchMyBetsHistory = async () => {

            try {
                const response = await fetch(`${import.meta.env.VITE_API_URL}/api/top-rounds`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({ option: isOption }), // Передаем userId в теле запроса
                });

                if (!response.ok) {
                    throw new Error(`Ошибка HTTP: ${response.status}`);
                }
                if (response.ok) {
                    const data = await response.json(); // Парсим ответ
                    console.log(data.result)
                    setTopRounds(data.result)
                    setIsLoading(false)
                }

            } catch (error) {
                console.error('Ошибка при выполнении запроса:', error);
            }
        };

        fetchMyBetsHistory();
        
    }, [isOption]); // Добавляем isUserId в зависимости

    function getDateDay(date) {
        const [datePart, timePart] = date.split('T');
        const dateParse = new Date(datePart)
        const options = { day: '2-digit', month: 'short' };
        const result = dateParse.toLocaleDateString('en-US', options)
        const resultArr = result.split(' ');
        return `${resultArr[1]}`
    }

    function getDateMonth(date) {
        const [datePart, timePart] = date.split('T');
        const dateParse = new Date(datePart)
        const options = { day: '2-digit', month: 'short' };
        const result = dateParse.toLocaleDateString('en-US', options)
        const resultArr = result.split(' ');
        return `${resultArr[0]}`
    }

    function getTime(date) {
        const [datePart, timePart] = date.split('T');
        const timeParts = timePart.split('.')
        return timeParts[0]
    }

    function getTime1(date) {
        const isoDate = "2025-05-14T05:31:20.824Z";

        // Преобразуем строку в объект Date
        const newDate = new Date(isoDate);
        
        // Получаем компоненты даты
        const day = String(newDate.getDate()).padStart(2, '0'); // День
        const month = String(newDate.getMonth() + 1).padStart(2, '0'); // Месяц
        const year = String(newDate.getFullYear()).slice(-2); // Последние 2 цифры года
        const hours = String(newDate.getHours()).padStart(2, '0'); // Часы
        const minutes = String(newDate.getMinutes()).padStart(2, '0'); // Минуты
        
        // Форматируем дату и время
        const formattedDateTime = `${day}.${month}.${year} ${hours}:${minutes}`;
        return formattedDateTime
    }

    function getColor(value) {
        let color = "rgb(52, 180, 255)";
        const parseCashout = parseFloat(value)

        if (parseCashout >= 2.00 && parseCashout < 10.00) {
            color = "rgb(145, 62, 248)"
          } else if (parseCashout >= 10.00) {
            color = "rgb(192, 23, 180)"
          }

          return {"color": color}
    }
    

    return (
        <>
            {/* <div className={'top-tab-switcher'}>

            <div className={'navigation-switcher'}>
                    <button className={`nav-tab ${isDay ? "active" : ""}`}
                            onClick={() => handleNavClick('allBets')}>{t("Day")}
                    </button>
                    <button className={`nav-tab ${isMonth ? "active" : ""}`}
                            onClick={() => handleNavClick('myBets')}>{t("Month")}
                    </button>
                    <button className={`nav-tab ${isYear ? "active" : ""}`}
                            onClick={() => handleNavClick('top')}>{t("Year")}
                    </button>
                </div>

            </div> */}
            <div className={'top-tab-legend'}>
                <span className={'top-tab-legend-date'}>
                    {t("Date")}
                </span>
                <div className={'x-fairness'}>
                    <span>X</span>
                    <span>{t("Fairness")}</span>
                </div>
            </div>
            <div className={"real-time-bets-wrapper rounds"}>
                            {isLoading ? <div className={`archive-loader-wrap show mybets-all`}>
                                <span className={'archive-loader'}></span>
                                </div> : ""
                            }                
                {topRounds.length > 0 ? (
                    topRounds.map((item, index) => (
                        index === 0 ? (
                            <div key={index} className={'multiplier-bet-item'}>
                            <div className={'multiplier-bet-item-date'}>
                                <span>{getTime1(item.createdAt)}</span>
                            </div>
                            <div className={'multiplier-info-result'} style={getColor(item.roundResult)}>{item.roundResult}x</div>
                            <div className={'multiplier-info-container'}>
                                <div className={'multiplier-fairness'} onClick={() => {
                                setRoundId(item.id)
                                setIsFairnessOpen(true)
                                console.log(roundId)
                            }}></div>
                            </div>
                        </div>
                        ) : (
                            <div key={index} className={'multiplier-bet-item'}>
                            <div className={'multiplier-bet-item-date'}>
                                <span>{getTime1(item.createdAt)}</span>
                            </div>
                            <div className={'multiplier-info-result'} style={getColor(item.roundResult)}>{item.roundResult}x</div>
                            <div className={'multiplier-info-container'}>
                                <div className={'multiplier-fairness'} onClick={() => {
                                setRoundId(item.id)
                                setIsFairnessOpen(true)
                                console.log(roundId)
                            }}></div>
                            </div>
                        </div>
                        )
                    ))
                ) : ""}

                

            </div>
            {isFairnessOpen && <FairnessModal isOpen={isFairnessOpen} onClose={closeFairnessModal} roundId={roundId}/>}
        </>
    )
}

export default Multipliers;